import { resetErrorStatus } from "@modules/global";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

const AccessDenied = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    useEffect(() => {
        return () => {
            dispatch(resetErrorStatus());
        };
    }, []);

    return (
        <div className={"content-wrapper error-page"}>
            <div className={"card card-error card-error-permission"}>
                <div className={"card-body"}>
                    <div>
                        <i className={"sprite sprite-error-permission"}></i>
                    </div>
                    <h2>{t(`common::msg::${"You don't have permission to view this page."}`)}</h2>
                    <p>{t(`common::msg::${"You do not have permission to access."}`)}</p>
                    <p>{t(`common::msg::${"If you want to access this page, please contact your administrator."}`)}</p>
                </div>
            </div>
        </div>
    );
};
export default AccessDenied;
